'use client';
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "./Disclaimer.css";
import '../tools/ToolsPage.css'

const Disclaimer = () => {
    return (
        <>
            <Header />
            <div className="tools-container">
                <h1 className="privacy-policy-title mb-2">Disclaimer</h1>

                <section>
                    <p>
                        The information provided on <strong>munichindians.com</strong> is for
                        general informational and guidance purposes only. All information on
                        the site is provided in good faith; however, we make no representation
                        or warranty of any kind, express or implied, regarding the accuracy,
                        adequacy, validity, reliability, or completeness of any information on
                        the site.
                    </p>
                    <p>
                        Under no circumstance shall we have any liability to you for any loss
                        or damage of any kind incurred as a result of the use of the site or
                        reliance on any information provided on the site. Your use of the site
                        and your reliance on any information on the site is solely at your own
                        risk.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">Affiliate Disclosure (Anzeige)</h2>
                    <p>
                        This website contains affiliate links. This means that if you click on
                        one of our affiliate links and make a purchase, we may receive a
                        commission or other compensation at no additional cost to you.
                    </p>
                    <p>
                        Our use of affiliate links helps to support the maintenance and
                        operation of this website, allowing us to continue providing valuable
                        content. Please note that the presence of an affiliate link does not
                        influence our content or recommendations. We only link to products,
                        services, or companies that we believe will be of value to our
                        community.
                    </p>
                    <p>
                        In Germany, commercial content must be clearly identified as
                        advertising. Therefore, any link from which we may earn a commission
                        is marked with <em>"Anzeige"</em>, <em>"Werbung"</em>, <em>"Ad"</em>,
                        or <em>"Sponsored"</em> and will be disclosed in direct proximity to
                        the link itself.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">No Professional Advice</h2>
                    <p>
                        The information on this website is intended for general guidance on
                        various topics related to life in Munich and Germany. It is not
                        professional advice.
                    </p>
                    <p>
                        We are not professional lawyers, financial advisors, or medical
                        practitioners. Therefore, the content on this website should not be
                        considered a substitute for professional legal, financial, or medical
                        advice. We strongly recommend that you seek the advice of a qualified
                        professional for any specific questions or concerns. While we strive
                        to ensure our content is up-to-date and accurate, we are not liable
                        for any outdated or incorrect information.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">External Links Disclaimer</h2>
                    <p>
                        Our website may contain links to external websites that are not
                        provided or maintained by or in any way affiliated with
                        munichindians.com.
                    </p>
                    <p>
                        Please be aware that we do not guarantee the accuracy, relevance,
                        timeliness, or completeness of any information on these external
                        websites. The inclusion of any link does not imply endorsement by us.
                        We have no control over the content and practices of these external
                        sites and cannot be held responsible or liable for any content,
                        advertising, products, or other materials on or available from them.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">User-Generated Content</h2>
                    <p>
                        This website allows users to post content, such as comments or forum
                        posts. We do not have direct legal authority over this user-generated
                        content.
                    </p>
                    <p>
                        The views and opinions expressed in user-generated content are those
                        of the respective authors and do not necessarily reflect our views or
                        opinions. We do not endorse or take responsibility for the accuracy or
                        legality of any user-generated content.
                    </p>
                    <p>
                        Users are solely responsible for the content they post. We reserve the
                        right to monitor, edit, or remove any content at our sole discretion
                        that we consider inappropriate, offensive, or in violation of our
                        community standards or applicable laws, but we are not obligated to do
                        so.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">Intellectual Property and Copyright</h2>
                    <p>
                        Unless otherwise stated, all original content, including all text,
                        images, and graphics, on this website is our intellectual property and
                        is protected by copyright law.
                    </p>
                    <p>
                        This includes content that may have been generated or modified using
                        AI tools such as Gemini, ChatGPT or similar platforms. The final
                        edited and published output is our intellectual property.
                    </p>
                    <p>
                        You may not reproduce, distribute or create derivative works from our
                        content without our express written permission.
                    </p>
                </section>

                <section>
                    <h2 className="section-title">Acceptance of this Disclaimer</h2>
                    <p>
                        By using this website, you hereby agree to and accept all terms and
                        conditions of this disclaimer. If you do not agree with any part of
                        this disclaimer, you must not use our website.
                    </p>
                </section>
            </div>
            <Footer />
        </>
    );
};

export default Disclaimer;
